import SuggestionModal from './SuggestionModal';

export default SuggestionModal;
